// extracted by mini-css-extract-plugin
module.exports = {"default":"LineAnimatedLink_default__uGrSg","inverse":"LineAnimatedLink_inverse__kKYAP"};